/**
 * Truncate text to a maximum of 65 characters, by using the class "show-accordion"
 */
(() => {
  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}...`;
    }
    return text;
  }

  document.querySelectorAll('td.show-accordion')
    .forEach((cell) => {
      const originalText = cell.textContent;
      const truncatedText = truncateText(originalText, 65);
      cell.querySelector('p').textContent = truncatedText;

      // Only create and append the arrow element if the text exceeds 65 characters
      if (originalText.length > 65) {
        const arrow = document.createElement('span');
        arrow.className = 'arrow';
        arrow.textContent = '▼'; // You can style this arrow with CSS
        cell.style.cursor = 'pointer';
        cell.appendChild(arrow);

        // Toggle text visibility on arrow click
        cell.addEventListener('click', () => {
          if (cell.textContent.includes('...')) {
            cell.querySelector('p').textContent = originalText;
            cell.appendChild(arrow); // Re-append the arrow
            cell.parentNode.classList.add('active');
          } else {
            cell.querySelector('p').textContent = truncatedText;
            cell.appendChild(arrow); // Re-append the arrow
            cell.parentNode.classList.remove('active');
          }
        });
      }
    });
})();

/**
 * dynamically add col title to data attribute
 */
(() => {
  const table = document.querySelector('.table-accordion');
  if (!table) return;

  const tableHead = table.querySelectorAll('thead td');
  tableHead.forEach((td, index) => {
    const titleP = td.querySelector('p');
    if (titleP) {
      td.classList.add(`${titleP.textContent.toLowerCase().replace(/ /g, '-')}`);
    }

    const tableRows = table.querySelectorAll('tbody tr');
    tableRows.forEach((tr) => {
      const trow = tr.querySelectorAll('td')[index];
      if (titleP) {
        trow.setAttribute('data-td', titleP.textContent.toLowerCase().replace(/ /g, '-'));
      }
    });
  });
})();
